import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageCbBnkseek} from "../../../../../../api/build";

@Component({
  selector: 'app-dict-qref-cbBnkseek',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefCbBnkseekViewComponent),
    multi: true
  }],
  template: `
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="newnum"
                         name="namep"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['namep','newnum']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.newnum }} </b>
          {{ item.namep }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <b> {{ item.newnum }} </b>
          {{ item.namep }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
  `
})
export class QrefCbBnkseekViewComponent extends ViewDictionaryBase<PageCbBnkseek> {
  getDictionary = this.dictSrv.getQrefCbBnkseekList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
